import React from "react";
import { Row } from "./Row/Row";
import { ResultsInIndex } from "./ResultsInIndex/ResultsInIndex";
import { Highlight } from "./Highlight/Highlight";
import { useNormalisedHits } from "@/features/search/components/Results/hooks/useNormalisedHits";
import { getCategoryPath } from "@/features/casino/utils/helpers";
import { CategoryIcon } from "@/features/casino/components/CategoryIcon";
import type { CasinoCategoryHit } from "@/features/search/components/Results/models/casinoCategoryHit";

const CasinoCategoriesResults = () => {
  const { items, results } = useNormalisedHits<CasinoCategoryHit>();

  return (
    <ResultsInIndex
      indexName={`Casino Categories`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const titleHighlight = item.normalisedHighlights?.title?.[0];

        return (
          <Row
            key={item.objectID}
            icon={<CategoryIcon iconUrl={item.iconUrl} size={10} />}
            title={
              <Highlight
                text={item.title}
                matchedWords={titleHighlight?.matchedWords || []}
                html={titleHighlight?.value || ""}
              />
            }
            to={getCategoryPath(item.objectID)}
          />
        );
      })}
    </ResultsInIndex>
  );
};

export { CasinoCategoriesResults };
